/**
 * @owlcat/realtime-voice (in-portal staging home).
 *
 * Self-contained realtime voice-session module. Kept dependency-free of
 * portal-specific code so it can later move to a shared package that habits
 * consumes too. Portal-specific bits (route paths, StoryBrief tool name) are the
 * only things a second app would re-point.
 */

export { CAUGHT_FIELDS, useRealtimeStorySession } from './useRealtimeStorySession';
export type { CaughtField, RealtimeStorySession } from './useRealtimeStorySession';
export { connectRealtime } from './webrtc';
export type { RealtimeConnection, ConnectOptions } from './webrtc';
export type {
  TranscriptEntry,
  SessionState,
  SessionError,
  StoryBrief,
  StartSessionResponse,
  ExistingCharacter,
  NewCharacter,
} from './types';
